"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForestsRejuvenationAbilityHandler = exports.ForestsRejuvenationActorAbilityFactory = exports.ForestsRejuvenationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/effects/core");
class ForestsRejuvenationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ForestsRejuvenation;
        this.__typeName = "ForestsRejuvenation";
    }
}
exports.ForestsRejuvenationAbilityArgs = ForestsRejuvenationAbilityArgs;
let ForestsRejuvenationActorAbilityFactory = class ForestsRejuvenationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ForestsRejuvenation", "OneAllies", 2);
    }
};
ForestsRejuvenationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ForestsRejuvenation")
], ForestsRejuvenationActorAbilityFactory);
exports.ForestsRejuvenationActorAbilityFactory = ForestsRejuvenationActorAbilityFactory;
let ForestsRejuvenationAbilityHandler = class ForestsRejuvenationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence.pushSequence("sequential")
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "feet"), "GreenHealingPillar"));
                container.applyHealing({
                    sequence: sequence,
                    healerId: ability.invokerId,
                    targetId: selectedAlly,
                    amount: container.getPercentOfBaseHealth(selectedAlly, 10),
                    onApplied: sequence => {
                        container.applyBuff({
                            sequence,
                            creatorId: ability.invokerId,
                            targetId: selectedAlly,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_2.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Health, container.getPercentOfBaseHealth(selectedAlly, 10)),
                        });
                    }
                });
            }
        });
    }
};
ForestsRejuvenationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ForestsRejuvenation)
], ForestsRejuvenationAbilityHandler);
exports.ForestsRejuvenationAbilityHandler = ForestsRejuvenationAbilityHandler;
